var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoCardsYet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 35,
    viewBox: "0 0 44 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6 7.4998H37.7999C41.2999 7.9998 43.8 11.3998 43.4 14.6998L41.4 28.7998C41.1 30.5998 40.4 32.2998 38.9 33.2998C37.6 34.2998 36.4 34.7998 34.9 34.7998H33.9L10.6 31.7998C8.09995 31.5998 6.09995 29.7998 5.39995 27.5998C2.69995 27.0998 0.699951 24.5998 0.699951 21.8998V5.9998C0.699951 2.7998 3.39995 0.299805 6.39995 0.299805H31.9C35.1 0.299805 37.6 2.7998 37.6 5.9998V7.4998ZM31.7 2.7998H6.39995C4.59995 2.7998 3.09995 4.1998 3.09995 5.9998V9.4998H34.9V5.9998C34.9 4.2998 33.4 2.7998 31.7 2.7998ZM3.09995 21.7998V11.8998H34.8V21.5998C34.8 23.2998 33.2999 24.7998 31.6 24.7998H6.39995C4.59995 25.0998 3.09995 23.5998 3.09995 21.7998ZM38.8 28.6998L40.8 14.5998C41.1 12.3998 39.6 10.3998 37.3 9.89981V21.7998C37.3 24.9998 34.7999 27.4998 31.6 27.4998H8.09995C8.79995 28.4998 9.79995 28.9998 10.8 29.1998L34.1 32.1998C36.2999 32.6998 38.6 30.8998 38.8 28.6998Z",
    fill: "#A8B6C1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCardsYet);
export default __webpack_public_path__ + "static/media/NoCardsYet.24af3181.svg";
export { ForwardRef as ReactComponent };